(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lx-countdown-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lx-countdown-bar')) {
customElements.define('lx-countdown-bar', class extends HTMLElement {
connectedCallback() {
this.h = this.querySelector('[data-h]');
this.m = this.querySelector('[data-m]');
this.s = this.querySelector('[data-s]');
if (!this.h) return;
this.tick = this.tick.bind(this);
this.tick();
this.timer = setInterval(this.tick, 1000);
}
disconnectedCallback() { clearInterval(this.timer); }
target() {
if (this.dataset.mode === 'fixed' && this.dataset.end) {
const fixed = new Date(this.dataset.end);
if (!isNaN(fixed)) return fixed;
}
const now = new Date();
return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
}
tick() {
const diff = Math.max(0, this.target() - new Date());
if (diff === 0 && this.dataset.mode === 'fixed' && this.dataset.hideExpired === 'true') {
this.hidden = true;
clearInterval(this.timer);
return;
}
const total = Math.floor(diff / 1000);
const pad = (n) => String(n).padStart(2, '0');
this.h.textContent = pad(Math.floor(total / 3600));
this.m.textContent = pad(Math.floor((total % 3600) / 60));
this.s.textContent = pad(total % 60);
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-reviews-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lx-reviews-grid')) {
customElements.define('lx-reviews-grid', class extends HTMLElement {
connectedCallback() {
this.list = this.querySelector('[data-list]');
if (!this.list) return;
this.cards = Array.from(this.list.querySelectorAll('[data-review]'));
this.nav = this.querySelector('[data-nav]');
this.prevBtn = this.querySelector('[data-prev]');
this.nextBtn = this.querySelector('[data-next]');
this.pageLabel = this.querySelector('[data-page]');
this.empty = this.querySelector('[data-empty]');
this.filterBtn = this.querySelector('[data-filter-photo]');
this.lightbox = this.querySelector('[data-lightbox]');
this.lightboxImg = this.querySelector('[data-lightbox-img]');
this.page = 0;
this.photoOnly = false;
this.mq = window.matchMedia('(max-width: 749px)');
this.onMq = () => { this.page = 0; this.render(); };
if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
const sort = this.querySelector('[data-sort]');
if (sort) sort.addEventListener('change', (event) => this.sort(event.target.value));
if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));
if (this.filterBtn) this.filterBtn.addEventListener('click', () => this.toggleFilter());
this.list.addEventListener('click', (event) => {
const btn = event.target.closest ? event.target.closest('[data-photo-open]') : null;
if (btn) this.openPhoto(btn);
});
if (this.lightbox) {
const close = this.querySelector('[data-lightbox-close]');
if (close) close.addEventListener('click', () => this.lightbox.close());
this.lightbox.addEventListener('click', (event) => { if (event.target === this.lightbox) this.lightbox.close(); });
this.lightbox.addEventListener('close', () => { if (this.lightboxImg) this.lightboxImg.removeAttribute('src'); });
}
this.render();
}
disconnectedCallback() {
if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
}
perPage() {
const n = parseInt(this.mq.matches ? this.dataset.mobile : this.dataset.desktop, 10);
return n > 0 ? n : 6;
}
pool() { return this.photoOnly ? this.cards.filter((card) => card.dataset.photo === '1') : this.cards; }
pages() { return Math.max(1, Math.ceil(this.pool().length / this.perPage())); }
toggleFilter() {
this.photoOnly = !this.photoOnly;
this.filterBtn.setAttribute('aria-pressed', String(this.photoOnly));
this.filterBtn.classList.toggle('is-active', this.photoOnly);
this.page = 0;
this.render();
}
sort(mode) {
const byIndex = (a, b) => a.dataset.index - b.dataset.index;
const cards = this.cards.slice();
if (mode === 'high') cards.sort((a, b) => (b.dataset.rating - a.dataset.rating) || byIndex(a, b));
else if (mode === 'low') cards.sort((a, b) => (a.dataset.rating - b.dataset.rating) || byIndex(a, b));
else cards.sort(byIndex);
cards.forEach((card) => this.list.appendChild(card));
this.cards = cards;
this.page = 0;
this.render();
}
go(step) {
this.page = Math.min(Math.max(this.page + step, 0), this.pages() - 1);
this.render();
this.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
openPhoto(btn) {
if (!this.lightbox || !this.lightboxImg || !btn.dataset.full) return;
this.lightboxImg.src = btn.dataset.full;
this.lightboxImg.alt = btn.dataset.alt || '';
this.lightbox.showModal();
}
render() {
const per = this.perPage();
const pool = this.pool();
const pages = Math.max(1, Math.ceil(pool.length / per));
if (this.page > pages - 1) this.page = pages - 1;
this.cards.forEach((card) => { card.hidden = true; });
pool.forEach((card, i) => { card.hidden = i < this.page * per || i >= (this.page + 1) * per; });
if (this.empty) this.empty.hidden = pool.length > 0;
if (!this.nav) return;
this.nav.hidden = pages < 2;
if (this.prevBtn) this.prevBtn.disabled = this.page === 0;
if (this.nextBtn) this.nextBtn.disabled = this.page >= pages - 1;
if (this.pageLabel) this.pageLabel.textContent = (this.page + 1) + ' / ' + pages;
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-ugc-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lx-ugc-videos')) {
customElements.define('lx-ugc-videos', class extends HTMLElement {
connectedCallback() {
this.track = this.querySelector('[data-track]');
this.dots = this.querySelector('[data-dots]');
this.modal = this.querySelector('[data-modal]');
this.modalVideo = this.querySelector('[data-modal-video]');
if (!this.track) return;
this.track.addEventListener('click', (event) => {
const card = event.target.closest('[data-card]');
if (card) this.open(card);
});
const closeBtn = this.querySelector('[data-close]');
if (closeBtn) closeBtn.addEventListener('click', () => this.modal.close());
if (this.modal) {
this.modal.addEventListener('click', (event) => { if (event.target === this.modal) this.modal.close(); });
this.modal.addEventListener('close', () => {
this.modalVideo.pause();
this.modalVideo.innerHTML = '';
this.modalVideo.removeAttribute('src');
this.modalVideo.load();
});
}
this.buildDots();
this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });
if ('ResizeObserver' in window) {
this.resizeObserver = new ResizeObserver(() => this.buildDots());
this.resizeObserver.observe(this.track);
}
if (this.dataset.autoplay === 'true' && 'IntersectionObserver' in window) {
this.io = new IntersectionObserver((entries) => {
entries.forEach((entry) => {
const video = entry.target;
if (entry.isIntersecting) { const p = video.play(); if (p && p.catch) p.catch(() => {}); } else { video.pause(); }
});
}, { threshold: 0.5 });
this.querySelectorAll('[data-card] video').forEach((video) => this.io.observe(video));
}
}
disconnectedCallback() {
if (this.io) this.io.disconnect();
if (this.resizeObserver) this.resizeObserver.disconnect();
}
open(card) {
const source = card.querySelector('video');
if (!source || !this.modal) return;
this.modalVideo.innerHTML = source.innerHTML;
if (source.poster) this.modalVideo.poster = source.poster;
this.modalVideo.load();
this.modal.showModal();
const p = this.modalVideo.play();
if (p && p.catch) p.catch(() => {});
}
pages() {
const sw = this.track.scrollWidth;
const cw = this.track.clientWidth;
return cw ? Math.max(1, Math.ceil(sw / cw)) : 1;
}
buildDots() {
if (!this.dots) return;
const count = this.pages();
if (count === this.dots.childElementCount) { this.updateDots(); return; }
this.dots.innerHTML = '';
if (count < 2) return;
for (let i = 0; i < count; i += 1) {
const dot = document.createElement('span');
dot.className = 'lx-ugc__dot';
this.dots.appendChild(dot);
}
this.updateDots();
}
updateDots() {
if (!this.dots || !this.dots.childElementCount) return;
const max = this.track.scrollWidth - this.track.clientWidth;
const progress = max > 0 ? this.track.scrollLeft / max : 0;
const active = Math.round(progress * (this.dots.childElementCount - 1));
Array.from(this.dots.children).forEach((dot, index) => dot.classList.toggle('is-active', index === active));
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
